export enum ActionSdkCommand {
    CreateActionInstance = "CreateActionInstance",
    CreateActionInstanceWithRows = "CreateActionInstanceWithRows",
    GetActionInstance = "GetActionInstance",
    UpdateActionInstance = "UpdateActionInstance",
    DeleteActionInstance = "DeleteActionInstance",
    SendActionInstanceReminder = "SendActionInstanceReminder",
    CreateOrUpdateActionInstanceRows = "CreateOrUpdateActionInstanceRows",
    GetActionInstanceRow = "GetActionInstanceRow",
    GetActionInstanceRows = "GetActionInstanceRows",
    DeleteActionInstanceRow = "DeleteActionInstanceRow",
    GetActionInstanceSummary = "GetActionInstanceSummary",
    DownloadActionInstanceResult = "DownloadActionInstanceResult",
    GetActionInstanceNonResponoders = "GetActionInstanceNonResponoders",
    GetConversationMembers = "GetConversationMembers",
    GetConversationMembersCount = "GetConversationMembersCount",
    GetUserProfiles = "GetUserProfiles",
    GetUserProfilePhotos = "GetUserProfilePhotos",
    SetNavBarMenuItems = "SetNavBarMenuItems",
    UploadMedia = "UploadMedia",
    DismissScreen = "DismissScreen",
    GetCurrentContext = "GetCurrentContext",
    LogTelemetry = "LogTelemetry",
    GetLocalizedActionStrings = "GetLocalizedActionStrings",
    ShowDiagnosticView = "ShowDiagnosticView",
    HideLoadingIndicator = "HideLoadingIndicator",
    ActionViewDidLoad = "ActionViewDidLoad",
    RegisterBackButtonHandler = "RegisterBackButtonHandler",
    GetTemplateActions = "GetTemplateActions",
    GetActionInstances = "GetActionInstances",
    SaveActionInstanceDraft = "SaveActionInstanceDraft",
    UpdateActionInstanceDraft = "UpdateActionInstanceDraft",
    GetDraftActionInstances = "GetDraftActionInstances",
    PromoteDraftToAction = "PromoteDraftToAction",
    CreateActionInstanceNoBot = "CreateActionInstanceNoBot",
    GetJoinedTeams = "GetJoinedTeams",
    GetListOfChannelsForGroups = "GetListOfChannelsForGroups"
}
